const KEY = 'divert.lastMemberId';

export const rememberMember = (id: string) => {
  try {
    sessionStorage.setItem(KEY, id);
  } catch {
    /* storage unavailable */
  }
};

export function lastMemberPath() {
  try {
    const id = sessionStorage.getItem(KEY);
    if (id) return `/analytics/members/${id}`;
  } catch {
    /* storage unavailable */
  }
  return '/members';
}
